export default __webpack_public_path__ + "static/media/no_image_sq.6a6219e3.png";